import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'countItemsByPositiveFlag',
})
export class CountItemsByPositiveFlag implements PipeTransform {
  transform(data: any[] = [], key: string): number {
    return data.filter((item) => item[key]).length;
  }
}
